"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownError = void 0;
const args_1 = require("../lib/args");
const error_codes_1 = require("../lib/error-codes");
const is_error_1 = require("./is-error");
/**
 * A generic error when something unexpected happened. You should generally avoid using this type of
 * error.
 */
class UnknownError extends is_error_1.IsError {
    constructor(messageOrError, errorOrArgs, args) {
        const { message, originalError, errorArgs } = (0, args_1.readErrorArgs)(messageOrError, errorOrArgs, args);
        super(error_codes_1.StatusErrorCode.UNKNOWN, UnknownError.name, message, errorArgs?.reasonCode || error_codes_1.ErrorGenericReasonCode.SERVER_ERROR, errorArgs?.userMessage || error_codes_1.ErrorMessage.SOMETHING_WENT_WRONG, originalError, errorArgs);
    }
}
exports.UnknownError = UnknownError;
